<template>
  <div>
    <div class="sign-up-title text-center mb-4">
      Create your {{ AppName }} individual profile
    </div>
    <identity-form :submitting="submitting" :state="state" :verify-key="verifyKey" @submit="onManagerSignUp" />
  </div>
</template>

<script>
import { AppName } from '@/helpers/constants'
import IdentityForm from '@/components/forms/CreateProfile/IdentityForm.vue'

export default {
  name: 'Identity',

  props: {
    verifyKey: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      AppName,
      state: {},
      submitting: false
    }
  },

  methods: {
    onManagerSignUp(data) {
      this.submitting = true
      this.$store.dispatch('signup/managerSignUp', data)
        .then(() => this.$emit('submitted'))
        .catch(errors => { this.state = errors })
        .finally(() => { this.submitting = false })
    }
  },

  components: {
    IdentityForm
  }
}
</script>
